import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginModel: null,
    accountModel: null,
    configurationModel: null,
    answerDataArray: [],
    redirectTo: null
  },

  mutations: {
    saveLoginModel(state, playload) {

      state.loginModel = playload
      // CacheTool.saveStoreState(state) //每次操作保存一下state备份。供App页面刷新时重新载入
    },

    saveAccountModel(state, playload) {
      state.accountModel = playload
    },

    saveConfigurationModel(state, playload) {
      state.configurationModel = playload
    },

    saveAnswerDataArray(state, playload) {
      state.answerDataArray = playload
    },

    setRedirectTo(state, path) {
      state.redirectTo = path;
    },

  },
  actions: {
  },
  modules: {
    user
  }
})
